export default __webpack_public_path__ + "cover.a41b9c9b.png";